<template>
  <div class="mt-3 p-2">
    <b-container fluid class="mb-2">
      <!-- Plot Details Section -->
      <h5>Plot Details</h5>
      <b-card class="user-details border-0 mb-3">
        <b-card-text>
          <table class="table table-sm ">
            <tr>
              <th>Project Name</th>
              <td>{{ plotDetails._project_id.name }}</td>
            </tr>
            <tr>
              <th>Zone Name</th>
              <td>{{ plotDetails._zone_id.code }}</td>
            </tr>
            <tr>
              <th>Plot Name</th>
              <td>{{ plotDetails._plot_id.code }}</td>
            </tr>
            <tr>
              <th>Registration Date</th>
              <td>{{ plotDetails.created_ts | moment("ddd,Do MMM  YYYY") }}</td>
            </tr>
          </table>
        </b-card-text>
      </b-card>

      <b-row no-gutters class="mb-3">
        <b-col cols="12" class="text-right"
          ><PlantAssetAssignment
            :plot_id="plotDetails._plot_id"
            @modified="getPlotDetails"
          ></PlantAssetAssignment
        ></b-col>
      </b-row>

      <b-table
        id="my-table"
        class="dataTable rounded-left"
        :outlined="true"
        :items="items"
        :fields="fields"
        head-variant="none"
        table-variant="none"
        :caption-top="true"
        show-empty
      >
        <template #empty="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template #table-caption>Plantation Assets</template>
        <template #cell(#)="data">{{ data.index + 1 }}</template>
        <template #cell(image)="row">
          <span v-if="row.item._asset_id">
            <img
              :src="row.item._asset_id.image"
              alt="asset image"
              height="100px"
              width="100px"
              style="border-radius: 10px"
            />
          </span>
          <span v-else>
            <span class="bg-danger">Deleted</span>
          </span>

        </template>
        <template #cell(status)="row">
          <span v-if="row.item.status == 1">
            completed
          </span>
          <span v-if="row.item.status == 0">
            pending
          </span>
        </template>
        <template #cell(plantation_date)="row">
          <span v-if="row.item.status == 1">
            {{ row.item.plantation_date | moment("ddd,Do MMM  YYYY") }}
          </span>
          <span v-if="row.item.status == 0">
            {{ row.item.planned_plantation_date | moment("ddd,Do MMM  YYYY") }}
          </span>
        </template>
        <template #cell(remarks)="row">
          {{row.item.remarks}}
        </template>
        <template #cell(action)="row">
          <b-row no-gutters>
            <b-col col="6">
              <PlantAssetAssignmentEdit
                :plot_id="plotDetails._plot_id"
                :data="row.item"
                @modified="getPlotDetails"
                :index="row.index"
              ></PlantAssetAssignmentEdit>
            </b-col>
            <b-col col="6">
              <div @click="deletePlotPlantationAssets(row.item._id)">
                <i class="fas fa-trash-alt"></i>
              </div>
            </b-col>
          </b-row>
        </template>
      </b-table>

      <b-table
        id="my-table"
        class="dataTable rounded-left"
        :outlined="true"
        :items="plotDetails._plot_id.activities"
        :fields="plotFields"
        head-variant="none"
        table-variant="none"
        :caption-top="true"
        show-empty
      >
        <template #empty="scope">
          <h4>{{ scope.emptyText }}</h4>
        </template>
        <template #table-caption>Plot Activities</template>
        <template #cell(#)="data">{{ data.index + 1 }}</template>
        <template #cell(_activiesId._activityTypeID)="{ item }">{{ (item._activiesId) ? item._activiesId?._activityTypeID?.name : item  }}</template>
        <template #cell(description)="{ item }"
        > <span v-html="item._activiesId?.description"></span></template>
        <template #cell(startDate)="{ item }">  {{  item._activiesId?.start_date }} </template>
        <template #cell(endDate)="{ item }">  {{  item._activiesId?.end_date }} </template>
        <template #cell(startDate)="{ item }">
          {{ item._activiesId?.start_date | moment("ddd,Do MMM  YYYY") }}
        </template>
        <template #cell(endDate)="{ item }">
          {{ item._activiesId?.end_date | moment("ddd,Do MMM  YYYY") }}
        </template>
        <template #cell(progress_status)="{ item }">
          <span v-if="item._activiesId?.progress_status == 1">
            Pending
          </span>
          <span v-if="item._activiesId?.progress_status == 2">
            In Progress
          </span>
          <span v-if="item._activiesId?.progress_status == 3">
            Completed
          </span>
        </template>
        <template #cell(progress)="{ item }">  {{  item._activiesId?.progress }} </template>

      </b-table>
    </b-container>
  </div>
</template>

<script>
import PlantAssetAssignment from "@/components/users/plots/PlantAssetAssignment";
import PlantAssetAssignmentEdit from "@/components/users/plots/PlantAssetAssignmentEdit";
export default {
  components: {
    PlantAssetAssignment,
    PlantAssetAssignmentEdit,
  },
  data() {
    return {
      plotDetails: "",
      plotPlantationDetails: "",
      fields: [
        "#",
        {
          key: "_asset_id.name",
          label: "Asset Name",
        },
        {
          key: "image",
          label: "Asset Image",
        },
        {
          key: "status",
          label: "Status",
        },
        {
          key: "plantation_date",
          label: "Plantation Date / Planned Plantation Date",
        },
        {
          key: "quantity",
          label: "Qty",
        },
        {
          key: "remarks",
          label: "Remarks",
        },
            ],
      items: [],
      plotFields: [
        "#",
        {
          key: "_activiesId._activityTypeID",
          label: "Activity Type",
        },
        {
          key: "description",
          label: "Activity Description",
        },
        {
          key: "startDate",
          label: "Start Date",
        },
        {
          key: "endDate",
          label: "End Date",
        },
        {
          key: "progress_status",
          label: "Status",
        },
        {
          key: "progress",
          label: "Progress(%)",
        },
      ],
    };
  },
  mounted() {
    this.getCustomerPlotDetails();
  },
  methods: {
    deletePlotPlantationAssets(id) {
      let plot_id = this.plotDetails._plot_id._id;
      this.getPlotDetails();
      let prompt = confirm("Are you sure want to delete ? ");
      if (prompt) {
        window.axios
          .delete("/asset-plot-alignment", {
            params: {
              plot_id,
              plantationAssetsId: id,
            },
          })
          .then((resp) => {
            if (resp.data.success) {
              this.getPlotDetails();
            }
          });
      }
    },

    getCustomerPlotDetails() {
      let id = this.$route.params.plot_id;
      window.axios.get("/customer-plots/details/" + id).then((resp) => {
        this.plotDetails = resp.data.data;
        this.getPlotDetails();
      });
    },
    getPlotDetails() {
      let plot_id = this.plotDetails._plot_id._id;
      console.log(plot_id);
      window.axios
        .get("/plot-asset", {
          params: {
            plot_id: plot_id,
          },
        })
        .then((resp) => {
          console.log(resp);
          this.plotPlantationDetails = resp.data.data;
          this.items = this.plotPlantationDetails.plantationAssets;
          console.log("Items");
          console.log(this.items);
        });
    },
  },
};
</script>

<style scoped>
.user-details .card {
  border-radius: 11px;
}

.user-details .card-body {
  background-color: #dcffd9;
  border-radius: 11px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

.table > tr:first-child > td,
.table > tr:first-child > th {
  border: none;
}

/deep/ .dataTable {
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}

/deep/ .dataTable thead {
  background-color: #e6e6e6;
  height: 51px;
  font-size: 18px;
  font-weight: 400;
  letter-spacing: 3.5%;
  font-family: "Poppins", sans-serif;
  padding-top: 14px;
  padding-bottom: 14px;
}

/deep/ .dataTable {
  text-align: center;
  margin-bottom: 21.5px;
  margin-left: 2px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
}
/deep/ .dataTable tr td {
  font-family: "Poppins", sans-serif;
  font-size: 17px;
  letter-spacing: 3.5%;
  line-height: 25.5px;
  font-weight: 400;
  padding-top: 12px;
  padding-bottom: 12px;
}

/deep/ .dataTable caption {
  border-radius: 10px 10px 0 0;
  height: 64px;
  width: 100%;
  background-color: #dcffd9;
  color: #000;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  letter-spacing: 3.5%;
  padding-left: 27px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 25px;
}

.fa-trash-alt {
  height: 18px;
  width: 30px;
  color: red;
}

.fa-trash-alt:hover {
  cursor: pointer;
}
</style>
